/**
 * Trạng thái của form
 */
export default {
  /**
   * Mode View
   */
  View: 'View',
  /**
   * Thêm
   */
  Add: 'Add',
  /**
   * Sửa
   */
  Edit: 'Edit',
  /**
   * Xóa
   */
  Delete: 'Delete',
  /**
   * Ghi sổ
   */
  Posted: 'Posted',
  /**
   * Bỏ ghi
   */
  UnPost: 'UnPost',
  /**
   * In
   */
  Print: 'Print',
};
